import React from 'react';
import { Badge } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getNameInCurrentLanguage } from 'helpers/intl';

import { getTextColor } from 'components/forms/autocomplete/Color';
import IntlDate from 'components/layout/IntlDate';

class AttributeValuesInline extends React.Component {
  render() {
    const {
      intl: { messages },
      appIntl,
      values,
    } = this.props;

    let entries = values.map((value, i) => {
      const isLast = i == values.length - 1;

      let text = getNameInCurrentLanguage(value.getValue(), appIntl);

      switch (value.getValue()[0].getType()) {
        case 'bool':
          if (text === 'yes') {
            text = messages.yes;
          } else {
            text = messages.no;
          }
          break;
        case 'date':
          text = <IntlDate date={getNameInCurrentLanguage(value.getValue(), appIntl)} />;
          break;
      }

      if (!isLast) {
        text += ', ';
      }

      return (
        <span key={i} class={isLast ? '' : 'm-r-5'}>
          {value.getColor() !== null ? (
            <Badge
              style={{ background: value.getColor(), color: getTextColor(value.getColor()) }}
              class="p-l-10 p-r-10 m-r-10"
            >
              {value.getColor()}
            </Badge>
          ) : null}
          <span class="semi-bold">{text}</span>
        </span>
      );
    });

    return <span>{entries}</span>;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default connect(mapStateToProps)(injectIntl(AttributeValuesInline));
